"use client"

import { FormattedMessage } from "react-intl"

import { Button, makeMessengerUri, TextButtonProps } from "@bullseye/components"

export const OpenActivityChatButton = ({
  isEnabled,
  channelId,
  variant = "secondary",
  outlined = false,
  loading = false,
}: {
  isEnabled: boolean
  channelId?: string
  variant?: TextButtonProps["variant"]
  outlined?: boolean
  loading?: boolean
}) => {
  return (
    <Button
      disabled={!isEnabled || loading}
      loading={loading}
      startIconType={isEnabled ? "chat" : "lock"}
      as="a"
      href={makeMessengerUri(channelId)}
      variant={variant}
      outlined={outlined}
    >
      {isEnabled ? (
        <FormattedMessage id="general.ctas.openChat" />
      ) : (
        <FormattedMessage id="activity.chat.register" />
      )}
    </Button>
  )
}
